module.exports = __webpack_public_path__ + "img/Shift from Management to Prevention of Diabetes.6d9f082e.jpg";